// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.app-input__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #394150;
  margin: 0 0 6px;
}

.app-input__required {
  color: #c44762;
  font-weight: 700;
}

.app-input__field {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  border: 1px solid #e3e7ef;
  border-radius: 12px;
  padding: 12px 14px;
  background: linear-gradient(120deg, #f8f9fb 0%, #f5f7fb 100%);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.12s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.app-input__field--with-icon {
  grid-template-columns: auto 1fr;
}

.app-input__field:hover {
  border-color: rgba(107, 64, 146, 0.35);
  box-shadow: 0 8px 20px rgba(107, 64, 146, 0.12);
}

.app-input__field:focus-within {
  border-color: var(--e-global-color-primary);
  box-shadow: 0 10px 24px rgba(107, 64, 146, 0.18);
  transform: translateY(-1px);
}

.app-input__field--error {
  border-color: #c44762;
  box-shadow: 0 10px 24px rgba(196, 71, 98, 0.14);
}

.app-input__field--readonly {
  background: #f9fafb;
  box-shadow: none;
}

.app-input__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(107, 64, 146, 0.12);
  color: var(--e-global-color-primary);
  font-size: 1.05rem;
}

.app-input__control {
  border: none;
  background: transparent;
  outline: none;
  font-size: 1rem;
  color: #111827;
  width: 100%;
}

.app-input__control::placeholder {
  color: #9ca3af;
}

.app-input__control:disabled,
.app-input__control[readonly] {
  color: #6b7280;
}

.app-input__error {
  margin: 6px 2px 0;
  color: #c44762;
  font-weight: 600;
  font-size: 0.95rem;
}

.app-input__hint {
  margin: 6px 2px 0;
  color: #6b7280;
  font-size: 0.95rem;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-shared/input/input.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,8EAAA;EACA,0CAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,sCAAA;EACA,+CAAA;AACF;;AAEA;EACE,2CAAA;EACA,gDAAA;EACA,2BAAA;AACF;;AAEA;EACE,qBAAA;EACA,+CAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AACF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.app-input__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  color: #394150;\n  margin: 0 0 6px;\n}\n\n.app-input__required {\n  color: #c44762;\n  font-weight: 700;\n}\n\n.app-input__field {\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #e3e7ef;\n  border-radius: 12px;\n  padding: 12px 14px;\n  background: linear-gradient(120deg, #f8f9fb 0%, #f5f7fb 100%);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.12s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}\n\n.app-input__field--with-icon {\n  grid-template-columns: auto 1fr;\n}\n\n.app-input__field:hover {\n  border-color: rgba(107, 64, 146, 0.35);\n  box-shadow: 0 8px 20px rgba(107, 64, 146, 0.12);\n}\n\n.app-input__field:focus-within {\n  border-color: var(--e-global-color-primary);\n  box-shadow: 0 10px 24px rgba(107, 64, 146, 0.18);\n  transform: translateY(-1px);\n}\n\n.app-input__field--error {\n  border-color: #c44762;\n  box-shadow: 0 10px 24px rgba(196, 71, 98, 0.14);\n}\n\n.app-input__field--readonly {\n  background: #f9fafb;\n  box-shadow: none;\n}\n\n.app-input__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: rgba(107, 64, 146, 0.12);\n  color: var(--e-global-color-primary);\n  font-size: 1.05rem;\n}\n\n.app-input__control {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 1rem;\n  color: #111827;\n  width: 100%;\n}\n\n.app-input__control::placeholder {\n  color: #9ca3af;\n}\n\n.app-input__control:disabled,\n.app-input__control[readonly] {\n  color: #6b7280;\n}\n\n.app-input__error {\n  margin: 6px 2px 0;\n  color: #c44762;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.app-input__hint {\n  margin: 6px 2px 0;\n  color: #6b7280;\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
